module.exports = __webpack_public_path__ + "img/userdingyueSj.1927f48d.png";